var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddMedication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73483652,9.28111348 L4.88382813,9.28111348 L4.89508554,6.97462413 C4.89642866,6.69943757 5.11988975,6.47706448 5.39507959,6.47706448 L6.39751401,6.47706448 C6.67365639,6.47706448 6.89751401,6.7009221 6.89751401,6.97706448 L6.89751401,9.28111348 L9.05804867,9.28111348 C9.33419104,9.28111348 9.55804867,9.50497111 9.55804867,9.78111348 L9.55804867,10.8049222 C9.55804867,11.0810646 9.33419104,11.3049222 9.05804867,11.3049222 L6.89125098,11.3049222 L6.89125098,13.4864012 C6.89125098,13.7625436 6.66739336,13.9864012 6.39125098,13.9864012 L5.38638657,13.9864012 C5.1102442,13.9864012 4.88638657,13.7625436 4.88638657,13.4864012 C4.88638657,13.4855506 4.88638874,13.4846999 4.88639308,13.4838493 L4.89751401,11.3049222 L2.73483652,11.3049222 C2.45869415,11.3049222 2.23483652,11.0810646 2.23483652,10.8049222 L2.23483652,9.78111348 C2.23483652,9.50497111 2.45869415,9.28111348 2.73483652,9.28111348 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-68.3%",
    y: "-53.3%",
    width: "236.6%",
    height: "233.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.95614138,4.92356858 C9.27500318,3.32054774 10.1351222,2.53744729 11.5364985,2.57426722 C13.0452744,2.76588343 13.9524661,3.76893029 14.2580735,5.58340779 L14.2628374,9.32757323 L10.4125401,9.32473329 C9.90501264,9.51441222 9.64884764,9.80531317 9.64404511,10.1974362 C9.63684131,10.7856206 10.2353005,11.0792458 10.4791033,11.1072764 C11.4698926,11.1064231 12.7279779,11.1035872 14.2533594,11.0987688 L14.2354372,14.2882305 C13.7666068,16.172039 12.9015449,17.1183827 11.6402514,17.1272615 C9.74831113,17.1405798 8.99445331,15.7943812 8.96178475,15.3458662 C8.88127313,14.496843 7.46434673,14.1536345 7.18560487,15.4327451 C7.20450921,17.0903607 8.40532533,17.9803891 9.55740125,18.6532101 C10.7094772,19.3260312 15.7448731,19.4836877 15.9497642,14.0857441 C15.9987031,10.7964174 16.0403492,7.93438046 16.0747026,5.49963327 C15.5725025,2.52373979 14.0076132,0.958850544 11.3800349,0.804965548 C8.20734736,0.734146814 6.75455319,3.72849511 6.96948136,4.74098829 C6.99534519,4.84459555 7.29623886,5.51061927 7.9684218,5.55007032 C8.41654375,5.57637101 8.74578361,5.3675371 8.95614138,4.92356858 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-54.8%",
    y: "-22.0%",
    width: "209.6%",
    height: "155.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-button-secondary",
    transform: "translate(-12.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notifications"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "medication-icon",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 11.000000)",
    id: "Group_279"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.447370, 12.728030) rotate(-45.000000) translate(-13.447370, -12.728030) translate(4.947370, 3.228030)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-4",
    transform: "translate(5.896443, 10.231733) rotate(-135.000000) translate(-5.896443, -10.231733) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMedication);
export default __webpack_public_path__ + "static/media/addMedication.86bac7682002879ee75746e2195a443c.svg";
export { ForwardRef as ReactComponent };